<template>
  <div>
    <top-bar heading="Worklogs"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3" v-if="loaded && submitted">
      <b-card class="text-center">
        <h3>Your assignment has been submitted!</h3>
      </b-card>
    </div>
    <div class="container-fluid mt-3" v-if="loaded && !submitted">
      <b-card header="Fill Out Worklog" no-body>
        <b-card-body class="p-3">
          <form-viewer :schema="form.schema" :form-id="form.id" v-model="form.data" :on-submit="submitForm"></form-viewer>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import Submissions from '../../mixins/Submissions';
import FormViewer from '../../components/Formio/FormViewer';

export default {
  name: 'Worklogs',
  components: {FormViewer},
  data () {
    return {
      user: {},
      form: {},
      loaded: false
    };
  },
  mixins: [Submissions],
  methods: {
    loadUser (id) {
      this.axios.get('/users/' + id).then(rsp => {
        this.user = rsp.data.data;
        this.loadForm(300);

      }).catch(err => this.$errorOut(err));
    },
    loadForm (id) {
      this.axios.get('/forms/' + id).then(rsp => {
        this.form = rsp.data;
        this.loaded = true;
      }).catch(err => this.$errorOut(err));
    },
    submitForm (data) {
      return new Promise((resolve, reject) => {
        let submission = {
          user_id: this.$auth.user().id,
          form_id: this.form.id,
          student_id: this.id,
          form_name: this.form.name,
          form_schema: this.form.schema,
          form_data: data
        };

        this.loaded = false;

        this.axios.post('/worklogs', submission).then(() => {
          this.$swal('Success', 'Form has been submitted', 'success');
          resolve();
          this.submitted = true;
          this.loaded = true;
        }).catch(err => {
          this.$errorOut(err);
          reject();
        });
      });
    }
  },
  mounted () {
    this.loadUser(this.id);
  },
  metaInfo: {
    title: 'Worklogs'
  },
  props: ['id']
};
</script>
